import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import { buildMerchStoreConfig } from '../storeAliasHelper';
import { data_STAGING } from './STAGING';

export const CyborgClassicHoodieProduct = {
  title: 'Cyborg Classic Black Hoodie',
  description: '100% organic Supima cotton. Made carbon neutral.',
  imgSrc: 'web_v2/all-products/merch/new/cyborg-classic-hoodie.png/w_1920',
  tag: 'popular',
  shopifyProductName: 'Cyborg Classic Hoodie',
  availableSizes: [
    MerchSizes.XS,
    MerchSizes.S,
    MerchSizes.M,
    MerchSizes.L,
    MerchSizes.XL,
    MerchSizes.XXL,
  ],
};

export const CyborgClassicHoodieShopifyMap: Record<
  ShopifyStore,
  {
    price: number;
    sizes: Record<MerchSizes, { variantId: string; checkoutUrl: string }>;
  }
> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? buildMerchStoreConfig<MerchSizes>({
        [ShopifyStore.AE]: {
          price: 195,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/44691289276658',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691289276658:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/44691289309426',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691289309426:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/44691289342194',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691289342194:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/44691289374962',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691289374962:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/44691289407730',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691289407730:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/44691289440498',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691289440498:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.US]: {
          price: 50,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40200411316320',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200411316320:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40200411349088',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200411349088:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40200411381856',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200411381856:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40200411414624',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200411414624:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40200411447392',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200411447392:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40200411480160',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200411480160:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.ROW]: {
          price: 50,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40718610956348',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718610956348:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40718611349564',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718611349564:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40718611382332',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718611382332:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40718611415100',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718611415100:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40718611447868',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718611447868:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40718611480636',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718611480636:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.IN]: {
          price: 3499,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/40737818738758',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737818738758:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40737798094918',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737798094918:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40737798160454',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737798160454:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40737798225990',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737798225990:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40737798291526',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737798291526:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40737798357062',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737798357062:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.EU]: {
          price: 46,
          sizes: {
            [MerchSizes.XS]: {
              variantId: 'gid://shopify/ProductVariant/49202717491518',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717491518:1?channel=buy_button',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/49202717524286',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717524286:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/49202717557054',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717557054:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/49202717589822',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717589822:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/49202717622590',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717622590:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/49202717655358',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202717655358:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.GB]: {
          price: 40,
        },
        [ShopifyStore.AU]: {
          price: 75,
        },
        [ShopifyStore.CA]: {
          price: 70,
        },
        [ShopifyStore.MX]: {
          price: 1069,
        },
        [ShopifyStore.SA]: {
          price: 216,
        },
        [ShopifyStore.ZA]: {
          price: 999,
        },
        [ShopifyStore.JP]: {
          price: 7800,
        },
      })
    : data_STAGING;
